import type { ServersConfig } from './types';

export const servers: ServersConfig = {
  "Pertento Runtime Script": {
    // command: `curl -s -o /dev/null -w "Time: %{time_total}s\nSize: %{size_download} bytes\n" --compressed "https://app.pertento.ai/pertentoRuntime.js"`,
    url: "https://scripts.pertento.ai/pertentoRuntime5.js.gz",
  },
  "Backend Server": {
    url: "https://backend.pertento.ai/api",
  },
  "Tracking Server": {
    url: "https://tracking.pertento.ai",
  },
  "Dashboard": {
    url: "https://app.pertento.ai",
  },
  "Database": {
    type: 'postgres',
    silent: true,
  },
};
